import { RouteType } from 'types/map';
import { getPathData } from './navigation';

// type DBRoute = {
//   id: number;
//   name: string;
//   routes: [{ x: number; y: number }];
//   color: string;
//   distance?: number;
//   duration
// };

function toLatLng(paths) {
  return paths.map((path) => [path.x, path.y]);
}

export async function getRoutes(): Promise<RouteType[]> {
  return fetch(`${process.env.SERVER_URL}/routes`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then((res) => res.json())
    .then((res: RouteType[]) => {
      res.forEach((route, index) => {
        res[index].routes = toLatLng(route.routes);
      });

      return res;
    })
    .catch((err) => {
      console.log('Fetch routes error', err);
      return [];
    });
}

export async function changeRoute(data: RouteType) {
  const { id } = data;
  return fetch(`${process.env.SERVER_URL}/routes/${id}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }).then((res) => {
    if (res.status !== 200) {
      throw 'Change failed';
    }
  });
}

export async function addRoute(data: RouteType) {
  const { id, name, color, routes } = data;
  return getPathData({ routes, id, name, color }).then(
    (newRoute: RouteType) => {
      return fetch(`${process.env.SERVER_URL}/routes`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newRoute),
      }).then((res) => {
        if (res.status !== 200) {
          throw 'Change failed';
        }
      });
    },
  );
}

export async function deleteRoute(id: string) {
  return fetch(`${process.env.SERVER_URL}/routes/${id}`, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id }),
  }).then((res) => {
    if (res.status !== 200) {
      throw 'Delete failed';
    }

    return res.json();
  });
}
